export const sourcesQParam = '_s=dam';

export const searchResultsEmptyState = `https://res.cloudinary.com/prod/image/upload/v1666186017/console/empty-states/no-results.svg?${sourcesQParam}`;
export const searchResultsEmptyStateDark = `https://res.cloudinary.com/prod/image/upload/v1701440563/console/empty-states/no-results-dark.svg?${sourcesQParam}`;
